import axios, { AxiosPromise } from 'axios';

import { DocumentoFinalidadeDTO } from '../type';

export const getFinalidades = (
  tipoCertidao: number
): AxiosPromise<DocumentoFinalidadeDTO[]> =>
  axios.get(`/api/documentofinalidade?tipoCertidao=${tipoCertidao}`);
